import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "order-2 md:order-first relative" }
const _hoisted_2 = { class: "overflow-hidden md:overflow-y-auto absolute inset-0 flex md:flex-none flex-col items-center pb-4 divHeight" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "check"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-round text-xl text-white" }, "done", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "text-black" }
const _hoisted_9 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "text-primary font-semibold h-full flex flex-col items-center justify-center text-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-round text-2xl" }, "add", -1)
const _hoisted_14 = {
  key: 0,
  class: "error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multi_level_select = _resolveComponent("multi-level-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("Vaš izbor tlakovcev za naročilo")), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tiles, (tile, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: tile,
          class: "flex flex-col items-center w-full"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass([{ 'checked': tile.active }, "py-3 mb-4 font-semibold border border-primary rounded-md h-24 cursor-pointer h-full flex flex-col items-center justify-center text-center tileCard-width"]),
            style: {"position":"relative"},
            onClick: ($event: any) => (_ctx.select(i))
          }, [
            (tile.active)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "mb-2 tileImage",
              style: _normalizeStyle({'background-image': 'url(' + tile.tileRender +')'})
            }, null, 4),
            _createElementVNode("div", _hoisted_8, _toDisplayString(tile.title), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: "text-primary text-center cursor-pointer",
                onClick: ($event: any) => (_ctx.openDrawer(i))
              }, _toDisplayString(_ctx.$t("Spremeni")), 9, _hoisted_10),
              _createElementVNode("div", {
                class: "text-primary text-center cursor-pointer",
                onClick: ($event: any) => (_ctx.removeTile(i))
              }, _toDisplayString(_ctx.$t("Odstrani")), 9, _hoisted_11)
            ])
          ], 10, _hoisted_4)
        ]))
      }), 128)),
      _createElementVNode("div", {
        class: _normalizeClass(["border border-dashed border-primary rounded-md h-24 cursor-pointer tileCard-width", _ctx.errors.tiles && 'error']),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openDrawer())),
        style: {"min-height":"6rem"}
      }, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("Dodaj nove tlakovce")), 1)
        ])
      ], 2),
      (_ctx.errors.tiles)
        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.errors.tiles), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_multi_level_select, {
        ref: "multiLevel",
        items: _ctx.items,
        selected: _ctx.tiles,
        "onUpdate:selected": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tiles) = $event))
      }, null, 8, ["items", "selected"])
    ])
  ]))
}